import { GrupoEmpresaEnergiaEnum, PlantillaConsentimientoPrevioEnum, TipoEmpresaServiciosEnum, type CreateEmpresaServiciosModel } from "@api/api";

export class CreateEmpresaServicios implements CreateEmpresaServiciosModel {
  Nombre: string = '';
  Tipo: TipoEmpresaServiciosEnum = TipoEmpresaServiciosEnum.Energia;
  DireccionContacto: string = '';
  NombreContacto: string = '';
  TelContacto: string = '';
  EmailContacto: string = '';
  ImagenB64: string = '';
  Activado: boolean = false;
  IdsGestoresSoporte: string[] = [];
  IdGrupoEmpresa: GrupoEmpresaEnergiaEnum | null = null;
  RequiereConsentimientoPrevio: boolean = false;
  IdPlantillaConsentimiento: PlantillaConsentimientoPrevioEnum | null = null;

  //Propiedades de tipo energia
  IdEsave: number | null = null;
  SincronizaEsave: boolean | null = null;

  //Propiedades de tipo agua
  CodigosProvinciaDondeOpera: number[] | null = null;

  //Propiedad extra
  FicheroB64: string = '';

  constructor(data?: Partial<CreateEmpresaServicios>) {
    Object.assign(this, data);
  }
}